/*
 * @Descripttion: AEB告警分类接口
 * @Author: panyufeng
 * @Date: 2025-05-06 16:38:47
 * @LastEditors: panyufeng
 * @LastEditTime: 2025-09-29 10:22:52
 */
import service from '@/utils/request'

// 列表数据查询
export const getList = (params: any) =>
  service.request({
    method: 'post',
    url: '/aebAlarmType/list',
    data: params
  })

// 编辑
export const editSetting = (params: any) =>
  service.request({
    method: 'post',
    url: '/aebAlarmType/edit',
    data: params
  })

// 新增
export const addSetting = (params: any) =>
  service.request({
    method: 'post',
    url: '/aebAlarmType/add',
    data: params
  })

// 删除
export const removeSetting = (params: any) =>
  service.request({
    method: 'post',
    url: '/aebAlarmType/remove',
    data: params
  })
